
const components = {
  shoppingCart: {
    title: 'Warenkorb',
    toggle: 'kub-cart',
    comp: 'app-cart',
    visible: true,
    id: 1
  },
  address: {
    title: 'Adresse',
    toggle: 'kub-address',
    comp: 'app-address',
    visible: false,
    id: 2
  },
  payment: {
    title: 'Übersicht und Bezahlung',
    toggle: 'kub-payment',
    comp: 'app-payment',
    visible: false,
    id: 3
  }
}

export default {
  components
}
